// ScrollToTop.js or ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      const timeoutId = setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // or 'auto' for instant scrolling
        });
      }, 100);

      return () => clearTimeout(timeoutId);

    }
  }, [pathname, hash]);

  return null;
}

// Make sure you have this export line at the end
export default ScrollToTop;
